import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/HomePage.css';
import InteractiveLogoSVG from '../components/InteractiveLogoSVG';
import ClientLogosMain from '../components/ClientLogosMain';
import Slider from '../components/Slider';
import SEOHelmet from '../components/SEOHelmet';

const HomePage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div className="home-page">
      <SEOHelmet 
        title="5N1PR İletişim Danışmanlığı | PR, Sosyal Medya, Prodüksiyon, Organizasyon ve Stüdyo Hizmetleri"
        description="5N1PR, kurumsal iletişim danışmanlığı alanında PR, sosyal medya yönetimi, prodüksiyon, organizasyon ve stüdyo hizmetleri sunan profesyonel bir ajans."
      />
      
      <Slider />
      
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container">
          <div className="hero-content">
            <h1 className={isVisible ? 'fade-in' : ''}>İletişim Stratejilerinizi Güçlendiriyoruz</h1>
            <p className={`hero-subtitle ${isVisible ? 'fade-in' : ''}`}>
              5N1PR olarak markanızın hikayesini en etkili şekilde anlatmanız için stratejik iletişim çözümleri sunuyoruz.
            </p>
            <div className={`hero-buttons ${isVisible ? 'fade-in' : ''}`}>
              <Link to="/hizmetlerimiz" className="btn btn-primary">Hizmetlerimizi Keşfedin</Link>
              <Link to="/iletisim" className="btn btn-secondary">Bizimle İletişime Geçin</Link>
            </div>
          </div>
        </div>
      </section>
            
      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Hizmetlerimiz</h2>
          <p className="section-description">
            Markanızın ihtiyaçlarına özel, entegre iletişim çözümleri sunuyoruz.
          </p>
          
         {/* <div className="interactive-logo-container">
            <InteractiveLogoSVG />
          </div>*/}

          <div className="interactive-logo-container">
            <InteractiveLogoSVG />
          </div>
          
          <p className="services-intro">
            5N1PR olarak, markanızın iletişim stratejisini güçlendirmek için kapsamlı hizmetler sunuyoruz. 
            PR'dan sosyal medya yönetimine, prodüksiyondan organizasyona kadar tüm iletişim ihtiyaçlarınız için 
            yanınızdayız.
          </p>
        </div>
      </section>
      
      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h2>Hakkımızda</h2>
              <p>
                5N1PR, kurumsal iletişim danışmanlığı alanında uzmanlaşmış, yaratıcı ve stratejik çözümler sunan 
                profesyonel bir ekipten oluşmaktadır. Müşterilerimizin ihtiyaçlarını anlamak, hedeflerine ulaşmalarına 
                yardımcı olmak ve marka değerlerini güçlendirmek için çalışıyoruz.
              </p>
              <p>
                Deneyimli ekibimiz, sektördeki en son trendleri ve teknolojileri takip ederek, her müşterimize 
                özel çözümler geliştiriyor. İletişim stratejilerinizi en etkili şekilde yönetmek için sizinle 
                birlikte çalışmaktan mutluluk duyarız.
              </p>
              <Link to="/hakkimizda" className="btn btn-primary">Daha Fazla Bilgi</Link>
            </div>
            <div className="about-image">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="5N1PR Ekibi" />
            </div>
          </div>
        </div>
      </section>
      
      {/* Clients Section */}
      <section className="clients-section">
        <div className="container">
          <h2 className="section-title">Müşterilerimiz</h2>
          <p className="section-description">
            Farklı sektörlerden birçok saygın marka ile çalışmaktan gurur duyuyoruz.
          </p>
          <ClientLogosMain />
        </div>
      </section>
      
      {/* Contact CTA Section */}
      <section className="contact-cta">
        <div className="container">
          <div className="cta-content">
            <h2>İletişim Stratejinizi Birlikte Geliştirelim</h2>
            <p>
              Markanızın iletişim ihtiyaçları için profesyonel çözümler sunmak üzere yanınızdayız. 
              Hemen iletişime geçin, stratejinizi birlikte geliştirelim.
            </p>
            <Link to="/iletisim" className="btn btn-primary btn-large">Bizimle İletişime Geçin</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
